export function capitalize(text)
{
    if (typeof (text) !== "string"
        || !text.length)
        return text;
    
    return text.charAt(0).toLocaleUpperCase() + text.slice(1);
}